module.exports = "pegasus/assets/theme5/twitter-icon.png";